<template>

  <Header
    label="Einfach Freude verschenken"
    :headline="voucher.name"
  />

  <section class="bg-white py-20">
    <div class="container lg:flex lg:space-x-20">
      <div class="flex-none lg:w-1/3 mb-8">
        <div class="inline-block bg-white p-1 rounded-md shadow-md max-w-sm w-full">
          <img
            v-if="voucher.cover"
            class="lazy block rounded bg-gray-100 w-full h-auto"
            :data-src="voucher.cover.url"
            :height="voucher.cover.height"
            :width="voucher.cover.width"
            :alt="voucher.cover.metadata?.alt ?? voucher.name"
          >
          <div v-else class="w-screen pb-[100%] rounded bg-gray-100 max-w-full"></div>
        </div>
      </div>
      <div class="flex-1 max-w-2xl">
        <h1 class="text-2xl text-blue-500 font-bold mb-4 mt-4">{{ voucher.name }}</h1>
        <p v-if="voucher.description" class="text-lg" v-html="voucher.description"></p>
        <hr class="border-gray-300 my-8">
        <form @submit.prevent="submit" method="POST" :action="route('cart.product')">
          <template v-if="voucher.options && voucher.options.length">
            <Select label="Gutscheinwert:" name="option" v-model="form.option" class="w-full sm:w-64">
              <option
                v-for="option in voucher.options"
                :value="option.id"
                :key="option.id"
              >{{ option.name }}</option>
            </Select>
            <hr class="border-gray-300 my-8">
          </template>
          <div class="flex items-center justify-between sm:justify-start space-x-8">
            <strong class="text-2xl text-blue-500">{{ formatPrice(price) }}</strong>
            <button class="button" type="submit">In den Warenkorb</button>
          </div>
        </form>
      </div>
    </div>
  </section>

  <!-- <section class="bg-white py-16">
    <div class="container lg:flex lg:space-x-16">
      <div class="flex-1 max-w-2xl">
        <h2 class="text-2xl leading-tight font-bold text-blue-500">
          Die DAS DA-Card.
        </h2>
        <p class="text-lg mt-6">
          Eine Zeit voller Ungewissheit liegt hinter uns. Umso mehr freuen wir uns, gemeinsam mit Ihnen wieder Kultur zu erleben.
          Um Ihnen großes Theatervergnügen mit maximaler Flexibilität zu ermöglichen, ist ab sofort die DAS DA-Card erhältlich.
        </p>
        <p class="text-lg mt-6">
          Ihre Vorteile:
        </p>
        <div class="text mt-4">
          <ul>
            <li>10% Ermäßigung beim Kauf der DAS DA-Card</li>
            <li>Vorgezogenes Vorkaufsrecht</li>
            <li>Sie ist einlösbar für alle DAS DA-Vorstellungen, ausgenommen: Theaterdinner und Gastveranstaltungen (Konzerte, Kabarett, Lesungen etc.)</li>
            <li>Über Onlineshop und Vorverkaufsstellen erhältlich und einlösbar</li>
            <li>Nicht personengebunden</li>
          </ul>
        </div>
      </div>
      <div class="flex-none lg:w-1/3">
        <img class="lazy max-w-sm w-full" data-src="https://www.dasda-tickets.de/media/DAS-DA-Card_Stack.png" alt="">
      </div>
    </div>
  </section> -->

  <!-- <section class="bg-gradient-to-r from-blue-500 to-blue-accent py-16">
    <div class="container">
      <div class="text-white max-w-2xl mx-auto text-center">
        <h3 class="text-2xl leading-tight font-bold mb-4">
          Print oder kein Print, das ist hier die Frage
        </h3>
        <p class="text-lg">
          Im Checkout haben Sie die Wahl: Lassen Sie sich Ihre DAS DA-Card als Printprodukt per Post von uns schicken oder erhalten Sie schnell und einfach per E-Mail den für den Ticketkauf benötigten DAS DA-Card-Code.
        </p>
      </div>
    </div>
  </section> -->

</template>

<script>
import Layout from 'Web/Layouts/WithCart.vue';
import Header from 'Web/Shared/Header.vue';
import Select from 'Web/Form/Fields/SelectField.vue';
import Icon from 'Web/Shared/Icon.vue';
import Link from 'Web/Shared/Link.vue';
import { useForm } from '@inertiajs/inertia-vue3/dist';
import formatPrice from '@/helpers/formatPrice';
import useMeta from '@/compose/meta';
import { ref, watchEffect } from 'vue';

export default {
  inheritAttrs: false,
  layout: Layout,
  components: {
    Header,
    Select,
    Icon,
    Link,
  },
  props: {
    voucher: Object,
    cart: Object,
  },
  setup(props) {
      const { assign } = useMeta();

    assign({ title: `DAS DA-Onlineshop - ${props.voucher.name}` });

    const price = ref();

    const form = useForm({
      option: null,
      type: 'voucher',
      id: props.voucher.id,
    });

    const options = props.voucher.options;

    if (options && options.length) {
      form.option = options[0].id;
    }

    watchEffect(() => {
      const options = props.voucher.options;

      if (options && options.length)
        price.value = options.find(option => option.id === form.option)?.price;
      else
        price.value = props.voucher.value
    });

    function submit(event) {
      form.post(event.target.action, {
        preserveScroll: true,
      });
    }

    return {
      formatPrice,
      submit,
      price,
      form,
    }
  }
}
</script>
